import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_If_you_are_a_new_userX_would_y_ELL,
  TXTWCL_Take_part_by_clicking_the_butt_ELL,
  TXTWCL_To_view_content_please_create__ELL,
  TXTWCL_We_are_sorryX_you_need_to_log__ELL
} from './AuthRequiredPage.messages.json';
import styles from './AuthRequiredPage.scss';

const AuthRequiredPage: React.FC = () => (
  <div className={styles.container}>
    <Translation tagName="h1" {...TXTWCL_To_view_content_please_create__ELL} />
    <Translation tagName="h2" {...TXTWCL_We_are_sorryX_you_need_to_log__ELL} />
    <p>
      <Translation {...TXTWCL_If_you_are_a_new_userX_would_y_ELL} />{' '}
      <Translation {...TXTWCL_Take_part_by_clicking_the_butt_ELL} />
    </p>
  </div>
);

export default AuthRequiredPage;
